import React,{StrictMode} from "react";
import {createRoot} from "react-dom/client";
import "./index.css";
import App from "./App.jsx"; // 将 .tsx 更改为 .jsx

// 获取根 DOM 元素，并创建一个 React 根
const rootElement = document.getElementById("root");

// 确保根元素存在
if(rootElement) {
  const root = createRoot(rootElement);

  // 渲染 React 应用
  root.render(
    // StrictMode 用于在开发模式下突出显示应用程序中潜在的问题
    <StrictMode>
      <App /> {/* 渲染您的主应用组件 */}
    </StrictMode>
  );
} else {
  // 如果找不到根元素，则打印错误消息
  console.error("Root element with ID 'root' not found in the document.");
}